import React from 'react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
export function Flexibility() {
  return <section className="w-full bg-ink py-28 sm:py-36 lg:py-52" aria-labelledby="flexibility-title" data-id="element-94" data-mp="1zrdgvrm8456p">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-95" data-mp="1l2zbpa1c44mz">
        <div className="max-w-3xl" data-id="element-96" data-mp="1q1tsy7jnll4z">
          <Reveal data-id="element-97" data-mp="1q0r5k9lji0tt">
            <p className="font-sans text-[10px] font-medium uppercase tracking-widest2 text-champagne sm:text-[11px]" data-id="element-98" data-mp="1q090qoktaeaa">
              A tu ritmo
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-99" data-mp="1g5qv3dvu48nu">
            <h2 id="flexibility-title" className="mt-8 font-sans text-[2rem] font-light uppercase leading-[1.1] text-ivory sm:text-5xl xl:text-[3.6rem]" data-id="element-100" data-mp="124mtyzwcxmfs">
              No tienes que dejar
              <br data-id="element-101" data-mp="2wie5y625siee" />
              lo que haces
            </h2>
            <p className="mt-4 font-serif text-3xl italic leading-snug text-champagne sm:text-4xl xl:text-[3rem]" data-id="element-102" data-mp="31hqtyu4rnvik">
              para explorar algo nuevo.
            </p>
          </Reveal>

          <Reveal delay={0.1} data-id="element-103" data-mp="1ehnygg795sjm">
            <p className="mt-10 max-w-xl font-sans text-[17px] font-light leading-relaxed text-steel-200 sm:text-lg" data-id="element-104" data-mp="19lfodh7wwpjb">
              Puedes comenzar conociendo la industria, el proceso y lo que
              implica, mientras continúas con tus responsabilidades actuales.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.14} data-id="element-105" data-mp="vm65uaw8hjc6">
          <p className="mt-16 border-t border-ivory/15 pt-12 font-sans text-[1.75rem] font-light uppercase leading-[1.1] tracking-[0.02em] text-ivory sm:mt-20 sm:text-5xl xl:text-[4rem]" data-id="element-106" data-mp="vlejzrsfuzz3">
            Primero conoce.
            <br data-id="element-107" data-mp="14jgl07c69smd" />
            <span className="text-champagne" data-id="element-108" data-mp="zmzu55dl905l">Después decide.</span>
          </p>
        </Reveal>

        <Reveal delay={0.18} data-id="element-109" data-mp="2g0q24n7tw8ki">
          <CtaButton label="Agendar una conversación" tone="champagne" className="mt-14" data-id="element-110" data-mp="2fzyimaria1al" />
        </Reveal>
      </div>
    </section>;
}